<template lang="pug">
#laudos-renovabio(v-loading='loadingRenovabio')
    BaseHeader(
        v-if='isLaudoUnico',
        :titulo="$t('mensagens.laudos.laudoElegibilidadeRenovabio')",
        icon='el-icon-plus',
        :btnTexto="$t('mensagens.laudos.solicitarLaudo')",
        :exibeBotao="usuarioLogado.isAnalyst ? false : true",
        @btnHeaderClicado='changeShowModalSelecionarTerritorio'
    )

    BaseHeader(
        v-else,
        :titulo="$t('mensagens.laudos.titulo')",
        icon='el-icon-plus',
        :btnTexto="$t('mensagens.laudos.solicitarLaudo')",
        :exibeBotao="usuarioLogado?.isAnalyst ? false : true",
        @btnHeaderClicado='changeShowModalSelecionarTerritorio'
    )

    .view-container-base-header
        .d-flex.laudo-margin
            SelecionarLaudo(@laudoUnico='atualizaLaudoUnico')

        .grid-display-laudos-dashboard
            .grid-bloco1
                h2.mb-3
                    |  {{ $t('mensagens.laudos.totalDeLaudos') }}
                CardTotalizadores(:dados='totalizadores')

            .grid-bloco2
                h2.mb-3
                    |  {{ $t('mensagens.laudos.laudosUltimos12Meses') }}
                .card-totalizadores-dashboard-laudos__grafico__tabela
                    CardTotalizadoresLaudosDashboard(
                        :dados-tabela='dadosTabela',
                        :dados-grafico='dadosGrafico'
                    )

        Filtros(@getFiltros='filtrar', :tipoLaudo='tipoLaudo')

        AcoesEmLote(
            :laudosSelecionadosDownload='laudosSelecionadosDownload || []',
            :totalPaginaLaudosSelecionados='laudosSelecionadosDownload.length',
            :laudos='laudos || []',
            :totalGeralLaudosProcessados='totalGeralLaudosProcessados || 0',
            :filtros='filtros || {}',
            :dataConsulta='dataConsulta',
            :totalPaginas='totalPaginas',
            @abrirModalUploadLote='abrirModalUploadLote',
            @limparSelecao='limparSelecao'
        )

        .lista-laudos
            LaudoListagem(
                :tableData='laudos',
                v-loading='loading',
                :showAnalystColumns='usuarioLogado?.isAnalyst',
                @handleSort='handleSort',
                @handleModalCancelamento='handleModalCancelamento',
                @handleModalInsercaoResultados='handleModalInsercaoResultados',
                @atualizarTabela='requestLaudos'
            )
            .px-3
                .d-flex.flex-row.justify-content-between.align-items-center.border-bottom
                    .tabela-rodape-somatorio-laudos
                        p {{ totalLaudos }} {{ $tc('mensagens.laudos.contadorLaudos', totalLaudos) }}
                    el-pagination(
                        :page-size='pageParams.size',
                        :current-page.sync='pageParams.page',
                        layout='prev, pager, next',
                        :total='totalLaudos',
                        @current-change='requestLaudos'
                    )
        ModalTipoLaudo(@getLaudos='getLaudos', @showModalCarsJaEncontrados='abrirModalCarsJaCadastrados', :showModalSelecionarTerritorios='showModalSelecionarTerritorios', @setarFecharModalTipoLaudo='setarFecharModalTipoLaudo')
        ModalCancelamentoLaudo(
            :idLaudo='idLaudo',
            :tipoLaudo='tipoLaudo',
            :show.sync='showModalCancelamento',
            @voltar='voltar'
        )
        ModalInsercaoResultados(
            v-if='rowInfo',
            :tipoLaudo='tipoLaudo',
            :show.sync='showModalInsercaoResultados',
            :rowInfo='rowInfo',
            @update:lista='requestLaudos'
        )
        ModalUploadLaudosEmLote(
            :show.sync='showModalUploadLaudosEmLote',
            ref='modalUploadLaudosEmLote',
            @atualizar='requestLaudos',
            @fechar='showModalUploadLaudosEmLote = false',
            @carJaCadastradosEncontrados='handleCarsDuplicadosEncontrados'
        )
        ModalLaudosJaSolicitados(
            :show.sync='mostrarModalCarsJaCadastrados',
            :isLote='isLote',
            :quantidadeCars='quantidadeCARs',
            :carsNovos='carsNovos',
            :infoLaudosParaCadastro='infoLaudosParaCadastro',
            :confirmacaoAutomatica='confirmacaoAutomatica',
            @getLaudos='getLaudos',
            @buttonClicked='handleButtonClicked'
        )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import LaudoListagem from '@/components/laudos/renovabio/LaudoListagem.vue';
import CardTotalizadores from '@/components/laudos/CardTotalizadores.vue';
import Filtros from '@/components/laudos/filtroLaudos.vue';
import ModalCancelamentoLaudo from '@/components/laudos/ModalCancelamentoLaudo.vue';
import AcoesEmLote from '@/components/laudos/renovabio/AcoesEmLote.vue';
import TipoLaudo from '@/constants/TipoLaudo';
import ModalTipoLaudo from '@/components/laudos/ModalTipoLaudo.vue';
import SelecionarLaudo from '@/components/laudos/SelecionarLaudo.vue';
import ModalInsercaoResultados from '@/components/laudos/ModalInsercaoResultadosLaudo.vue';
import CardTotalizadoresLaudosDashboard from '@/views/laudos/dashboard/CardTotalizadoresLaudosDashboard.vue';
import ModalUploadLaudosEmLote from '@/components/laudos/renovabio/ModalUploadLaudosEmLote.vue';
import ModalLaudosJaSolicitados from '@/components/laudos/renovabio/ModalLaudosJaSolicitados.vue';

import LaudoService from '@/services/LaudosService';
import formatters from '@/utils/formatters';
import EventBus from '@/utils/eventBus';
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'LaudoRenovabio',
    components: {
        BaseHeader,
        LaudoListagem,
        SelecionarLaudo,
        Filtros,
        ModalInsercaoResultados,
        ModalCancelamentoLaudo,
        ModalTipoLaudo,
        AcoesEmLote,
        ModalUploadLaudosEmLote,
        ModalLaudosJaSolicitados,
        CardTotalizadores,
        CardTotalizadoresLaudosDashboard
    },
    computed: {
        ...mapGetters(['usuarioLogado', 'uploadLoteRenovabioConcluido']),
        ...mapState(['usuarioIsLaudo'])
    },
    data() {
        return {
            tipoLaudo: TipoLaudo.RENOVABIO,
            dadosGrafico: {
                loading: true,
                erro: false,
                payload: {
                    colunas: [],
                    itens: []
                }
            },
            dadosTabela: {
                loading: true,
                erro: false,
                payload: {
                    colunas: [],
                    itens: [],
                    visualizar: false
                }
            },
            showModalSelecionarTerritorios: false,
            showModalCancelamento: false,
            isLote: false,
            isTerritorio: false,
            idLaudo: null,
            laudos: [],
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC',
                total: 0
            },
            filtros: {
                dataCadastroFim: '',
                dataCadastroInicio: '',
                dataFinalizacaoFim: '',
                dataFinalizacaoInicio: '',
                representantesCpfCnpj: [],
                situacaoIds: [],
                car: '',
                territoriosIds: [],
                tipoLaudoId: TipoLaudo.RENOVABIO
            },
            dataConsulta: null,
            rowInfo: null,
            totalLaudos: 0,
            usuariosBuffer: {},
            showModalInsercaoResultados: false,
            loading: false,
            isLaudoUnico: false,
            tipoBusca: 'CAR',
            totalizadores: {},
            showModalUploadLaudosEmLote: false,
            laudosSelecionadosDownload: [],
            laudosRenovabio: [],
            quantidadeCARs: 0,
            infoLaudosParaCadastro: [],
            carsNovos: [],
            mostrarModalCarsJaCadastrados: false,
            totalGeralLaudosProcessados: 0,
            totalPaginas: 0,
            solicitacaoLaudoRenovabio: {},
            loadingRenovabio: false,
            confirmacaoAutomatica: false
        };
    },
    watch: {
        uploadLoteRenovabioConcluido: {
            async handler(newValue) {
                if (newValue) {
                    await this.getLaudos();
                }
            }
        }
    },
    async mounted() {
        if (this.usuarioIsLaudo) {
           this.$router.push({ name: 'LaudoAvaliacaoSocioambiental' });
        }
        await this.getLaudos();

        EventBus.$off('laudos:setar-lista-laudos-download-em-lote');
        EventBus.$on(
            'laudos:setar-lista-laudos-download-em-lote',
            laudosSituacaoProcessado => {
                this.laudosSelecionadosDownload = laudosSituacaoProcessado;
            }
        );
    },
    created() {
        if (this.$route.query.acao === 'SOLICITAR_LAUDO_RENOVABIO') {
            this.loadingRenovabio = true;
            this.solicitacaoLaudoRenovabio = this.$route.query;
            this.$notify.info({
                message: this.$t('mensagens.sistema.redirecionadoParaTelaSolicitacaoLaudo')
            });
            this.changeShowModalSelecionarTerritorio();
        }
    },
    methods: {
        handleButtonClicked(action) {
            if (this.resolveModalPromise) {
                this.resolveModalPromise(action);
                this.mostrarModalCarsJaCadastrados = false;
            }
        },

        async getLaudos() {
            await this.requestLaudos();
            await this.requestTotalizadores();
            await this.getQuantidadeLaudosProcessados();
            await this.buscarTotalizadoresSituacaoMensal();
        },

        setarFecharModalTipoLaudo() {
            this.showModalSelecionarTerritorios = false;
        },

        changeShowModalSelecionarTerritorio() {
            this.showModalSelecionarTerritorios =
                !this.showModalSelecionarTerritorios;
            this.showBusca();
        },

        abrirModalCarsJaCadastrados(
            quantidadeCARs,
            laudosInfo,
            carsNovos,
            confirmacaoAutomaticaLaudo
        ) {
            this.quantidadeCARs = quantidadeCARs;
            this.carsNovos = carsNovos;
            this.infoLaudosParaCadastro = laudosInfo;
            this.mostrarModalCarsJaCadastrados = true;
            this.confirmacaoAutomatica = confirmacaoAutomaticaLaudo;
            this.isLote = false;
            this.isTerritorio = false;
        },

        abrirModalCarsJaCadastradosLote(quantidadeCARs) {
            return new Promise(resolve => {
                this.isLote = true;
                this.mostrarModalCarsJaCadastrados = true;
                this.quantidadeCARs = quantidadeCARs;
                this.resolveModalPromise = resolve;
            });
        },

        async handleCarsDuplicadosEncontrados(quantidadeCARs) {
            const decisao = await this.abrirModalCarsJaCadastradosLote(
                quantidadeCARs
            );

            if (this.$refs.modalUploadLaudosEmLote) {
                this.$refs.modalUploadLaudosEmLote.prosseguirBaseadoNaDecisao(
                    decisao
                );
            }
        },

        solicitarLaudos(idsTerritoriosSelecionados) {
            let idsTerritorio = '';
            idsTerritoriosSelecionados.forEach(id => {
                idsTerritorio += id + '-';
            });
            this.$router.push({
                name: 'LaudoSolicitacaoRenovabio',
                params: { idsTerritorio }
            });
        },

        async requestLaudos() {
            try {
                this.loading = true;
                const { data } = await LaudoService.requestLaudos(
                    this.filtros,
                    this.pageParams
                );
                this.totalLaudos = Number(data?.totalItens);
                this.laudos = data?.laudos;
                this.pageParams.total = data.totalItens;
                this.totalPaginas = data.totalPaginas;
                this.dataConsulta = data.dataConsulta;

                if (this.filtros.tipoLaudoId === TipoLaudo.RENOVABIO) {
                    this.laudosRenovabio = data.laudos;
                }
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possivel carregar os dados.'
                });
            } finally {
                this.loading = false;
            }
        },

        async handleSort(paramsProp) {
            this.pageParams = {
                page: this.pageParams?.page,
                size: 20,
                sort: `${paramsProp?.column},${paramsProp?.order}`
            };
            await this.getLaudos();
        },

        async filtrar(filtros) {
            this.filtros = { ...filtros };
            await this.getLaudos();
        },

        handleModalInsercaoResultados(rowInfo) {
            this.rowInfo = rowInfo;
            this.showModalInsercaoResultados =
                !this.showModalInsercaoResultados;
        },

        handleModalCancelamento(laudo) {
            this.showModalCancelamento = !this.showModalCancelamento;
            this.idLaudo = laudo;
        },

        voltar() {
            this.getLaudos();
        },

        async requestTotalizadores() {
            try {
                const { data } = await LaudoService.buscarTotalizadoresSituacao(this.filtros.tipoLaudoId);
                this.totalizadores = data;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.laudos.erro.naoFoiPossivelCarregarOsDadosDosTotalizadores'
                    )
                });
            } finally {
                this.loading = false;
            }
        },

        atualizaLaudoUnico(laudoUnico) {
            this.isLaudoUnico = laudoUnico === 'true';
        },

        onChangeHandle() {
            this.showBusca();
        },

        showBusca() {
            if (this.tipoBusca === 'CAR') {
                $('#idTerritorio').addClass('none');
                $('#idCar').removeClass('none');
            } else {
                $('#idCar').addClass('none');
                $('#idTerritorio').removeClass('none');
            }
            this.loadingRenovabio = false;
        },

        atualizarDadosTabela(itens) {
            this.dadosTabela = {
                loading: false,
                erro: false,
                payload: {
                    colunas: [
                        this.$t('mensagens.laudos.meses'),
                        this.$t('mensagens.laudos.solicitados'),
                        this.$t('mensagens.laudos.naFila'),
                        this.$t('mensagens.laudos.emProcessamento'),
                        this.$t('mensagens.laudos.processado'),
                        this.$t('mensagens.laudos.cancelado'),
                        this.$t('mensagens.laudos.falhaNoProcessamento')
                    ],
                    codigo: ['meses', 'solicitados', 'naFila', 'emProcessamento', 'processados', 'cancelado', 'falhaProcessamento'],
                    itens: itens,
                    visualizar: false
                }
            };
        },
        atualizarDadosGrafico(
            colunas,
            solicitados,
            naFila,
            emProcessamento,
            processados,
            cancelado,
            falhaProcessamento
        ) {
            let itens = [];
            itens.push({
                name: this.$t('mensagens.laudos.solicitados'),
                data: solicitados
            });
            itens.push({
                name: this.$t('mensagens.laudos.naFila'),
                data: naFila
            });
            itens.push({
                name: this.$t('mensagens.laudos.emProcessamento'),
                data: emProcessamento
            });
            itens.push({
                name: this.$t('mensagens.laudos.processado'),
                data: processados
            });
            itens.push({
                name: this.$t('mensagens.laudos.cancelado'),
                data: cancelado
            });
            itens.push({
                name: this.$t('mensagens.laudos.falhaNoProcessamento'),
                data: falhaProcessamento
            });
            this.dadosGrafico = {
                loading: false,
                erro: false,
                payload: {
                    colunas: colunas,
                    itens: itens
                }
            };
        },

        async buscarTotalizadoresSituacaoMensal() {
            const { data } =
                await LaudoService.buscarTotalizadoresSituacaoMensal(TipoLaudo.RENOVABIO);
                let itens = [];
            let colunas = [];
            let solicitados = [];
            let naFila = [];
            let emProcessamento = [];
            let processados = [];
            let cancelado = [];
            let falhaProcessamento = [];
            for (const element of data) {
                colunas.push(element.mesAbreviado);
                solicitados.push(element.solicitados);
                naFila.push(element.naFila);
                emProcessamento.push(element.emProcessamento);
                processados.push(element.processados);
                cancelado.push(element.cancelado);
                falhaProcessamento.push(element.falhaProcessamento);
                itens.push({
                    mes: element.mesDescricao,
                    solicitados: this.formatNumber(element.solicitados),
                    naFila: this.formatNumber(element.naFila),
                    emProcessamento: this.formatNumber(element.emProcessamento),
                    processados: this.formatNumber(element.processados),
                    cancelado: this.formatNumber(element.cancelado),
                    falhaProcessamento: this.formatNumber(element.falhaProcessamento)
                });
            }
            this.atualizarDadosTabela(itens);
            this.atualizarDadosGrafico(
                colunas,
                solicitados,
                naFila,
                emProcessamento,
                processados,
                cancelado,
                falhaProcessamento
            );
        },

        formatNumber(number) {
            return formatters.formatNumber(number, 0);
        },

        async getQuantidadeLaudosProcessados() {
            let filtros = {
                ...this.filtros,
                situacaoId: 2,
                tipoLaudoId: TipoLaudo.RENOVABIO
            };
            try {
                const { data } =
                    await LaudoService.quantidadeLaudosRenovabioProcessados(
                        filtros
                    );
                this.totalGeralLaudosProcessados = data;
            } catch (error) {
                this.$notify.error({
                    message:
                        'Não foi possivel carregar os dados de laudos processados.'
                });
            }
        },

        abrirModalUploadLote() {
            this.showModalUploadLaudosEmLote = true;
        },

        limparSelecao() {
            this.laudosSelecionadosDownload = [];
            EventBus.$emit('laudos:limpar-selecao');
        }
    }
};
</script>

<style scoped lang="scss">
#laudos-renovabio {
    #modal-renovabio {
        .dialog-header {
            background-color: #e9e9e9;
            color: #00413c;
            padding: 15px;
            margin: -20px -20px 20px -20px;
            font-size: 18px;
            font-weight: 600;
            border-radius: 5px, 5px, 0px, 0px;
            box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
        }
        .el-dialog__body {
            max-height: 525px;
            padding: 15px;
        }

        .filtro-tipo-consulta {
            color: #00413c;
        }
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .laudo-margin {
        margin-bottom: 20px;
        background-color: var(--white);
        width: 100%;
        padding: 16px;
        overflow: hidden;
        border-radius: 4px;
    }

    .selecionados,
    .nao-selecionados {
        display: flex;
        flex-direction: column;

        .el-checkbox {
            width: 100%;
            display: flex;
            align-items: center;

            .el-checkbox__label {
                display: flex;
                flex-direction: column;

                p {
                    line-height: 16px;
                }
            }

            em {
                font-weight: 200;
                font-size: 12px;
            }
        }
    }

    .lista {
        background: var(--white);
        border-radius: 4px;
        overflow: hidden;
        min-height: 55vh;
        max-height: 72vh;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .radio-group-container {
        max-width: 250px;
        height: 20px;
        display: flex;
        justify-content: flex-start;
    }

    .radio-button {
        margin-right: 20px !important;
    }

    .busca-territorio {
        margin-top: 40px !important;
    }

    .busca-car {
        margin-top: 40px !important;
    }

    .none {
        display: none !important;
    }

    .titulo-tela {
        display: flex;
        justify-content: space-between;
        align-items: flex-end !important;
        height: 25px;
    }

    .buttonCard {
        height: 60px;
        top: 15px;
        position: relative;
    }
}
</style>
